import React, { useState } from 'react';
import AuthForm from '../components/AuthForm';
import { useUser } from '../contexts/UserContext';

export default function ForgotPasswordPage() {
  const { forgotPassword } = useUser();

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError('Unable to send reset email. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>Reset Link Sent</h2>
        <p>Check your email for a link to reset your password.</p>
      </div>
    );
  }
  
  return (
    <AuthForm
      title="Reset your password"
      image="/login.jpg"
      fields={[
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          value: email,
          onChange: (e) => setEmail(e.target.value),
        },
      ]}
      onSubmit={handleSubmit}
      submitLabel="Send Reset Link"
      showSocialIcons={false}
      footerLinks={[
        { href: '/login', label: 'Back to login' },
      ]}
    >
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
    </AuthForm>
  );
}
